import { makeStyles } from '@material-ui/core/styles';

// Components
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Alert from 'components/CncUI/Alert';
import Button from 'components/CncUI/Button';

import { GetApp as DownloadIcon } from '@material-ui/icons';

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  header: {
    marginTop: 40,
    marginBottom: 0,
    [breakpoints.up('lg')]: {
      fontSize: 48,
      lineHeight: '56px',
    },
  },
  description: {},
  alert: {
    '& p': {
      margin: 0,
    },
  },
}));

const Td1s = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={3} direction="column">
      <Grid item xs={12} id="Header">
        <Typography variant="h2" className={classes.header}>
          My TD-1s
        </Typography>
      </Grid>
      <Grid item xs={6} className={classes.description} id="Description">
        <Alert info className={classes.alert}>
          <Typography bold>Canadian Residents</Typography>
          <Typography>
            We’re working to support filling in your TD-1 through MyCast&Crew
            that’s set to launch soon.
          </Typography>
        </Alert>
      </Grid>
      <Grid item xs={6}>
        <Typography>
          Click the button below to download, print, and physically fill out the
          TD-1. The form will need to be turned into your supervisor.
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              startIcon={<DownloadIcon />}
              href="https://www.canada.ca/en/revenue-agency/services/forms-publications/td1-personal-tax-credits-returns/td1-forms-pay-received-on-january-1-later.html"
            >
              Download Form TD-1 (Federal & Provincial)
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              startIcon={<DownloadIcon />}
              href="https://www.revenuquebec.ca/en/online-services/forms-and-publications/current-details/tp-1015-3-v/"
            >
              Download Form Source Deductions (Quebec)
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Td1s;
